import { useEffect } from "react";
import IconoCircular from "./IconoCircular";
export default function CompContacto({ setPagina }) {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="content contacto">
      <section className="full-height">

        <div className="row-contacto">
          <h1>Hablemos</h1>
          <p>Actualmente resido en <a href="https://es.wikipedia.org/wiki/Logro%C3%B1o" target="_blank" rel="noopener noreferrer" aria-label="logroño">Logroño, La Rioja.</a></p>
          <p>Puedes ponerte en contacto conmigo a través de mi correo:</p>
          <p><a className="contact" href="mailto:sergiosalmat@gmail.com">sergiosalmat@gmail.com</a></p>
          <p>O por teléfono:</p>
          <p><a className="contact" href="tel:+34678624064">(+34) 678 62 40 64</a></p>
          <div className="botonera">
            <a href="https://www.linkedin.com/in/sergio-s-4b29452a/" target="_blank" rel="noopener noreferrer" aria-label="linkedin"> <IconoCircular size="pequeno" ruta="/images/LinkedIn_icon.svg" /></a>
            <a href="https://wa.me/34678624064" target="_blank" rel="noopener noreferrer" aria-label="linkedin"> <IconoCircular size="pequeno" ruta="/images/whatsapp.svg" /></a>
          </div>
        </div>

        <button className="button-big" onClick={() => setPagina("inicio")}>Volver al inicio</button>

      </section>

    </div>
  );
}
